import { createFileRoute } from '@tanstack/react-router'
import { EnTermsPage } from '~/components/marketing/en/en-terms-page'
import { marketingPageHead } from '~/lib/site-meta'

const TITLE = 'Terms of Use | Planno'
const DESCRIPTION =
  'Planno’s Terms of Use: registration, acceptable use, intellectual property, payments, and general provisions. English translation; the Portuguese version governs.'

export const Route = createFileRoute('/en/terms-of-use')({
  component: EnTermsPage,
  head: () =>
    marketingPageHead({
      description: DESCRIPTION,
      locale: 'en',
      path: '/en/terms-of-use',
      title: TITLE,
    }),
})
